module.exports = __webpack_public_path__ + "images/illustrations/illustration-a360-a878363d3f3f7d711191880a725b00b6.webp";